import PropTypes from 'prop-types';
import ActionAlert from './ActionAlert';
import css from './action-alert.module.scss';

const ActionSuccessAlert = ({ localizedText }) => (
  <ActionAlert localizedText={localizedText}>
    <div className={css.successCheckmark} />
  </ActionAlert>
);

ActionSuccessAlert.propTypes = {
  localizedText: PropTypes.string.isRequired,
};

export default ActionSuccessAlert;
